import { Kicker } from "./Reveal";
import SplitText from "./motion/SplitText";
import ImageReveal from "./motion/ImageReveal";

export default function PageHeader({ kicker, title, subtitle, image, imageAlt = "", testid = "page-header" }) {
  return (
    <section
      className="relative overflow-hidden border-b border-line pt-[72px] md:pt-20"
      style={{ backgroundImage: "radial-gradient(60% 70% at 85% 30%, rgba(230,240,234,0.95), transparent 70%)" }}
      data-testid={testid}
    >
      <div className="grid-bg pointer-events-none absolute inset-0" aria-hidden />
      <div className="relative mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-5 pb-14 pt-14 md:grid-cols-12 md:pb-20 md:pt-20">
        <div className={image ? "md:col-span-7" : "md:col-span-10"}>
          <Kicker>{kicker}</Kicker>
          <SplitText
            as="h1"
            text={title}
            delay={0.1}
            className="mt-4 font-display text-[2.3rem] font-semibold leading-[1.1] tracking-[-0.01em] text-ink sm:text-5xl lg:text-[3.9rem]"
            data-testid={`${testid}-title`}
          />
          {subtitle && (
            <SplitText
              as="p"
              text={subtitle}
              delay={0.5}
              stagger={0.012}
              duration={0.7}
              className="mt-6 max-w-[62ch] text-lg leading-relaxed text-body md:text-xl"
              data-testid={`${testid}-subtitle`}
            />
          )}
        </div>
        {image && (
          <ImageReveal
            src={image}
            alt={imageAlt}
            direction="left"
            className="aspect-[4/3] rounded-[10px] shadow-[0_30px_60px_-30px_rgba(18,33,27,0.35)] md:col-span-5 md:aspect-[4/5] md:max-h-[520px]"
            data-testid={`${testid}-image`}
          />
        )}
      </div>
    </section>
  );
}
